import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface ImageWithTextProps {
  image: string;
  title: string;
  description: string;
  reverse?: boolean;
  children?: ReactNode;
}

const ImageWithText = ({
  image,
  title,
  description,
  reverse = false,
  children,
}: ImageWithTextProps) => {
  return (
    <div className={`grid md:grid-cols-2 gap-8 md:gap-12 items-center ${reverse ? 'md:flex-row-reverse' : ''}`}>
      <motion.div 
        className="rounded-xl overflow-hidden shadow-lg"
        initial={{ opacity: 0, x: reverse ? 20 : -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <img
          src={image}
          alt={title}
          className="w-full h-auto object-cover"
        />
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, x: reverse ? -20 : 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true, margin: "-100px" }}
      >
        <h3 className="font-sans text-2xl md:text-3xl font-bold mb-4">{title}</h3>
        <p className="text-neutral-600 mb-6">{description}</p>
        
        {children}
      </motion.div>
    </div>
  );
};

export default ImageWithText;